import MonthYear from './MonthYear';
import SelectFromDB from './SelectFromDB';
import SelectTemplate from './SelectTemplate';

const components = {
  monthYear: MonthYear,
  selectFromDB: SelectFromDB,
  selectTemplate: SelectTemplate,
};

export default components;
